module.exports = __webpack_public_path__ + "media/icons/shopping-cart-3ce2fff6.svg";